// ======= plugin import ======= //
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React,{useState, useEffect} from 'react'
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay, faXmark } from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";
import ReactPlayer from 'react-player';
// ====== component import ====== //
import { SectionHeader_2 } from '../../../../component/landingComponent';
const Resource = () => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
        else{
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [location]);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        // responsive: [
        //     {
        //         breakpoint: 1024,
        //         settings: {
        //             slidesToShow: 4,
        //         },
        //     },
        //     {
        //         breakpoint: 768,
        //         settings: {
        //             slidesToShow: 3,
        //         },
        //     },
        //     {
        //         breakpoint: 480,
        //         settings: {
        //             slidesToShow: 2,
        //         },
        //     },
        // ],
    };

    const [playingVideo1, setPlayingVideo1] = useState(false);
	const [videoPlayerKey1, setVideoPlayerKey1] = useState(0);

    const isOpenVideoModal = () => {
        setPlayingVideo1(true);
    }
    const isCloseVideoModal = () => {
        setPlayingVideo1(false);
		setVideoPlayerKey1(prev => prev + 1);
    }

    const [ playingVideo2, setPlayingVideo2 ] = useState(false);
    const [ videoPlayerKey2, setVideoPlayerKey2 ] = useState(0);

    const isOpenVideoModal2 = () => {
        setPlayingVideo2(true)
    }
    const isClosedVideoModal2 = () => {
        setPlayingVideo2(false)
        setVideoPlayerKey2(prev => prev + 1);
    }


    return (
        <>

            <style>
                {
                    `.video-modal{
                        background-color:#0000005c;
                    }
                    .video-modal .cursor-pointer{
                        position:absolute;
                        background:#fff;
                        padding:12px 15px;
                        border-radius:50%;
                        margin:14px;
                        right:15px;
                    }
                    `
                }
            </style>
            <section className="hero-area hero-area-background">
                <div className="container">
                    <div className="text-center px-20">
                        <div className="section-heading">
                            <div className="title-wrapper">
                                <h2 className="section-title has_fade_anim fs-4x text-grad-1 pb-6">
                                    Explore the latest innovations
                                </h2>
                            </div>
                            <div className="text-wrapper mt-0">
                                <p className="text has_fade_anim mt-3 fs-1  text-grad-3">
                                    In Conversational AI, NLP, NLG, Data Science
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className='container'>
                    <div className='row mt-20 mb-20'>
                        <div className='col-md-6'>
                            <div className="position-relative">
                                <img 
                                    alt="tv-logo" 
                                    className="w-100 rounded" 
                                    src={('/assets/img/resource/tv-video-1.jpg')}
                                />
                                <div 
                                    className='ripple-wrapper cursor-pointer' 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#video_modal_1"
                                    onClick={isOpenVideoModal}
                                >
                                    <FontAwesomeIcon 
                                        icon={faCirclePlay} 
                                        className='fs-5x position-absolute top-50 start-50 translate-middle'
                                        style={{color: '#f61616', background:'#fff', borderRadius: '50%'}}
                                    />
                                    <span className="ripple-circle"></span>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="position-relative">
                                <img 
                                    alt="tv-logo" 
                                    className="w-100 rounded"
                                    src={('/assets/img/resource/tv-video-2.jpg')}
                                />
                                <div 
                                    className='ripple-wrapper cursor-pointer' 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#video_modal_2"
                                    onClick={isOpenVideoModal2}
                                >
                                    <FontAwesomeIcon 
                                        icon={faCirclePlay} 
                                        className='fs-5x position-absolute top-50 start-50 translate-middle'
                                        style={{color: '#f61616', background:'#fff', borderRadius: '50%'}}
                                    />
                                    <span className="ripple-circle"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row pt-20 px-10 mb-20'>
                        <div className='col-md-12 text-center mb-20'>
                            <SectionHeader_2
                                title={`What’s clients say`}
                            />
                        </div>
                        {/* <Slider {...settings}> */}
                            <div className='col-md-4'>
                                <div className='card bg-light-primary p-5 h-100'>
                                    <div className='card-body'>
                                        <div className="d-flex align-items-center">
                                            <div className="symbol symbol-50px me-3">
                                                <img src="/assets/img/tvicon/tv-pricing.png" className="" alt="" />
                                            </div>
                                            <div className="d-flex justify-content-start flex-column ms-3">
                                                <div className="text-gray-800 fw-bold text-hover-primary mb-1 fs-2">
                                                    Modi Properties
                                                </div>
                                                <span className="text-gray-400 fw-semibold d-block fs-6">
                                                    Syed Waseem Akhtar
                                                </span>
                                            </div>
                                        </div>
                                        <p className="fw-semibold text-gray-600 fs-5 mt-5 d-block">
                                            TruVoice works exactly as its name. It assists the business by sharing proper and true information with customers. We are glad to going for TruAssist.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card bg-light-primary p-5 h-100'>
                                    <div className='card-body'>
                                        <div className="d-flex align-items-center">
                                            <div className="symbol symbol-50px me-3">
                                                <img src="/assets/img/tvicon/tv-pricing.png" className="" alt="" />
                                            </div>
                                            <div className="d-flex justify-content-start flex-column ms-3">
                                                <div className="text-gray-800 fw-bold text-hover-primary mb-1 fs-2">
                                                    Centa
                                                </div>
                                                <span className="text-gray-400 fw-semibold d-block fs-6">
                                                    Centre for Teacher Accreditation
                                                </span>
                                            </div>
                                        </div>
                                        <p className="fw-semibold text-gray-600 fs-5 mt-5 d-block">
                                            TruVoice dons as Virtual Customer Support Assistant for Centa.org for all inquiries and support requests across WhatsApp and Mobile App channels.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='card bg-light-primary p-5 h-100'>
                                    <div className='card-body'>
                                        <div className="d-flex align-items-center">
                                            <div className="symbol symbol-50px me-3">
                                                <img src="/assets/img/tvicon/tv-pricing.png" className="" alt="" />
                                            </div>
                                            <div className="d-flex justify-content-start flex-column ms-3">
                                                <div className="text-gray-800 fw-bold text-hover-primary mb-1 fs-2">
                                                    Yogasadhna
                                                </div>
                                                <span className="text-gray-400 fw-semibold d-block fs-6">
                                                    Client Name
                                                </span>
                                            </div>
                                        </div>
                                        <p className="fw-semibold text-gray-600 fs-5 mt-5 d-block">
                                            TruVoice automates entire Lead Management and Customer Engagement for Yoga Sadhana, a school of classical Hatha Yoga in Australia.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        {/* </Slider> */}
                    </div>
                    <div className="row pt-20 px-10 mb-20">
                        <div className='col-md-12 text-center mb-20'>
                            <SectionHeader_2
                                title= {`Perspectives and update`}
                            />
                        </div>
                        <section className="blog-area pb-0">
                            <div className="container">
                                <div className="blog-area-inner">
                                    <div className="blog-wrapper-box">
                                        <div className="blog-wrapper">
                                            <article className="blog border" style={{borderRadius:20}}>
                                                <div className="thumb">
                                                    <a href="blog-details.html">
                                                        <img
                                                            src={('/assets/img/resource/robot-1.jpg')}
                                                            alt="blog image" 
                                                        />
                                                    </a>
                                                </div>
                                                <div className="content p-5 pt-0">
                                                    <div className="meta">
                                                        <span className="date fs-5">Artificial Intelligence</span>
                                                    </div>
                                                    <h3 className="title my-5 text-gray-700 fs-1x">
                                                        Artificial Intelligence versus humans, who will win?
                                                    </h3>
                                                    <div className="text-wrapper">
                                                        <p className="text fs-3">
                                                            Artificial Intelligence is a computer program of a higher order and nothing else
                                                        </p>
                                                    </div>
                                                    <div className="author-info d-flex align-items-center">
														<div className="symbol symbol-40px symbol-circle me-3">
															<img  
                                                                src={('/assets/img/resource/vamsi.png')}
                                                                className="" alt="" 
                                                            />
														</div>			
                                                        <div className="m-0">
                                                            <span className="fw-semibold text-gray-600 d-block fs-5 mb-2">
                                                                Mr. Vamsi Krishna
                                                            </span>
                                                            <div className="fw-bold text-gray-800 fs-6">
                                                                Sep 05, 2019
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </article>
                                            <article className="blog border" style={{borderRadius:20}}>
                                                <div className="thumb">
                                                    <a href="blog-details.html">
                                                        <img 
                                                            src={('/assets/img/resource/tech.png')} alt="blog image" 
                                                        />
                                                    </a>
                                                </div>
                                                <div className="content p-5 pt-0">
                                                    <div className="meta">
                                                        <span className="date fs-5">Customer Service</span>
                                                    </div>
                                                    <h3 className="title my-5 text-gray-700 fs-1x">
                                                        Automating Credit Cards Customer Service
                                                    </h3>
                                                    <div className="text-wrapper">
                                                        <p className="text fs-3">
                                                            Automating customer service for Credit Cards is anything but simple.
                                                        </p>
                                                    </div>
                                                    <div className="author-info d-flex align-items-center">
														<div className="symbol symbol-40px symbol-circle me-3">
															<img  src={('/assets/img/resource/vamsi.png')} className="" alt="" />
														</div>			
                                                        <div className="m-0">
                                                            <span className="fw-semibold text-gray-600 d-block fs-5 mb-2">
                                                                Mr. Vamsi Krishna
                                                            </span>
                                                            <div className="fw-bold text-gray-800 fs-6">
                                                                Sep 05, 2019
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </article>
                                            <article className="blog border" style={{borderRadius:20}}>
                                                <div className="thumb">
                                                    <a href="blog-details.html">
                                                        <img 
                                                            src={('/assets/img/resource/robot-2.png')}
                                                            alt="blog image" 
                                                        />
                                                    </a>
                                                </div>
                                                <div className="content p-5 pt-0">
                                                    <div className="meta">
                                                        <span className="date fs-5">NLG</span>
                                                    </div>
                                                    <h3 className="title my-5 text-gray-700 fs-1x">
                                                        Making Natural Language Generation (NLG) work for your business
                                                    </h3>
                                                    <div className="text-wrapper">
                                                        <p className="text fs-3">
                                                            You have read about GPT3 or GPTJ or T5 or other Natural Language Generation (NLG)
                                                        </p>
                                                    </div>
                                                    <div className="author-info d-flex align-items-center">
														<div className="symbol symbol-40px symbol-circle me-3">
															<img src={('/assets/img/resource/vamsi.png')} className="" alt="" />
														</div>			
                                                        <div className="m-0">
                                                            <span className="fw-semibold text-gray-600 d-block fs-5 mb-2">
                                                                Mr. Vamsi Krishna
                                                            </span>
                                                            <div className="fw-bold text-gray-800 fs-6">
                                                                Sep 05, 2019
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </article>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </section>

            <div className="modal fade modal-lg video-modal" id="video_modal_1" data-bs-backdrop="false" data-bs-keyboard="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body p-0">
                            <div
                                className="cursor-pointer text-end me-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={isCloseVideoModal}
                            >
                                <FontAwesomeIcon icon={faXmark} className='fs-1 text-grey-700' />
                            </div>
                            <ReactPlayer
                                url="https://www.youtube.com/embed/ZNlfpHp04D0?rel=0&amp;start&amp;end&amp;controls=1&amp;mute=0&amp;modestbranding=0?autoplay=1"
                                controls={true}
                                playing={playingVideo1}
                                loop={true}
                                key={videoPlayerKey1}
                                width="100%"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade modal-lg video-modal" id="video_modal_2" data-bs-backdrop="false" data-bs-keyboard="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body p-0">
                            <div
                                className="cursor-pointer text-end me-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={isClosedVideoModal2}
                            >
                                <FontAwesomeIcon icon={faXmark} className='fs-1 text-grey-700' />
                            </div>
                            <ReactPlayer
                                url="https://www.youtube.com/embed/5p8dv1ljUVg?rel=0&amp;start&amp;end&amp;controls=1&amp;mute=0&amp;modestbranding=0?autoplay=1"
                                controls={true}
                                playing={playingVideo2}
                                loop={true}
                                key={videoPlayerKey2}
                                width="100%"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export {Resource}